import { create } from 'zustand';

const useEmpresaStore = create((set) => ({
  empresa_id: null,
  empresa_ids: null,
  setEmpresaId: (id) => set({ empresa_id: id }),
  setEmpresaIds: (ids) => set({ empresa_ids: ids }),
  clearEmpresa: () => set({ empresa_id: null, empresa_ids: null }),
}));

export default useEmpresaStore;